var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDotMoreFolder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "5px",
    viewBox: "0 0 24 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDotMoreFolder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.533333,4.25 C1.296215,4.25 0.293333,3.309798 0.293333,2.15 C0.293333,0.990202 1.296215,0.05 2.533333,0.05 C3.770451,0.05 4.773333,0.990202 4.773333,2.15 C4.773333,3.309798 3.770451,4.25 2.533333,4.25 Z M11.69697,4.25 C10.459852,4.25 9.45697,3.309798 9.45697,2.15 C9.45697,0.990202 10.459852,0.05 11.69697,0.05 C12.934088,0.05 13.93697,0.990202 13.93697,2.15 C13.93697,3.309798 12.934088,4.25 11.69697,4.25 Z M20.860606,4.25 C19.623488,4.25 18.620606,3.309798 18.620606,2.15 C18.620606,0.990202 19.623488,0.05 20.860606,0.05 C22.097724,0.05 23.100606,0.990202 23.100606,2.15 C23.100606,3.309798 22.097724,4.25 20.860606,4.25 Z",
    id: "icDotMoreFolder",
    fill: "#333333",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDotMoreFolder);
export default __webpack_public_path__ + "static/media/icDotMoreFolder.1be0e4d980202448afcc81c4d05b600f.svg";
export { ForwardRef as ReactComponent };